import uuid from 'uuid';

import PermissionService from '@services/permission.service';
import jwtService from '@services/jwt.service';
import featureService from '@services/feature.service';

export const ROOT_MENU = 'root';


const permissionsService = new PermissionService()

function isFeatureEnabled({ featureName, featureFlags }) {
    if (typeof featureFlags === 'function') {
        return featureFlags(featureService);
    }
    return featureService.getFeature(featureName);
}

function hasAccessToMenuItem({ accessConfiguration }) {
    if (typeof accessConfiguration === 'function') {
        return accessConfiguration(permissionsService.permissions, { orgId: jwtService.getOrganizationId() });
    }
    return true;
}

export default function traverseMenuItems(menuConfig, hasAccess = hasAccessToMenuItem) {
    return (function mapChildrenToParent(list, parent) {
        let [item, ...other] = list;

        if (typeof item === 'function') {
            item = item();
        }

        if (!item) {
            return [];
        }

        if (!item.isRenderable || !isFeatureEnabled(item)) {
            return mapChildrenToParent(other, parent);
        }

        const itemCopy = {
            id: uuid(),
            parent: ROOT_MENU,
            ...item,
            ...(!item.children && {
                isVisible: hasAccess(item)
            }),
            ...(parent && {
                parent: parent.id,
                ...(item.routeTo && {
                    routeTo: parent.routeTo.concat(item.routeTo)
                })
            })
        };

        let { children } = itemCopy;

        if (children) {
            itemCopy.children = mapChildrenToParent(children, itemCopy);
        }

        if (parent) {
            const result = parent.newNav || (itemCopy.isVisible && parent.isVisible === undefined);

            if (result) {
                parent.isVisible = hasAccess(parent);
            }
        }

        return itemCopy.isVisible
            ? [itemCopy, ...mapChildrenToParent(other, parent)]
            : [...mapChildrenToParent(other, parent)];
    })(menuConfig);
}
